<template>
  <div>
    <Form :label-width="150" label-position="right" ref="params" :model="params" :rules="ruleValidate">
      <FormItem label="优惠券名称:" prop="cname">
        <label v-if="!this.viewMode">
          <Input
            placeholder="请输入优惠券名称"
            style="width: 60%"
            v-model="params.cname"
          ></Input>
        </label>
        <label v-else>
          <span>{{params.cname}}</span>
        </label>
      </FormItem>
      <!-- <FormItem label="发放平台:">
        <label>
          <span>{{ params.platformName }}</span>
        </label>
      </FormItem> -->
      <FormItem label="优惠券类型:">
        <label>
          <span>{{ params.ctypeName }}</span>
        </label>
      </FormItem>
      <Row v-show="params.ctype==='1'">
        <Row v-if="params.rule.meet.r1.ctype">
          <Col span="12">
            <FormItem label="优惠规则:">
              <Col span="24">
                <span style="padding-right: 20px;">满</span>
                <label>
                  <span>{{ params.rule.meet.r1.amountstep }}</span>
                </label>
                <span style="padding-left: 10px;padding-right: 10px;">减</span>
                <label>
                  <span>{{ params.rule.meet.r1.amount }}</span>
                </label>
              </Col>
            </FormItem>
          </Col>
        </Row>
        <Row v-if="params.rule.meet.r2.ctype">
          <Col span="12">
            <FormItem label="优惠规则:">
              <Col span="24">
                <span style="padding-right: 10px;">每满</span>
                <label>
                  <span>{{ params.rule.meet.r2.amountstep }}</span>
                </label>
                <span style="padding-left: 10px;padding-right: 10px;">减</span>
                <label>
                  <span>{{ params.rule.meet.r2.amount }}</span>
                </label>
              </Col>
            </FormItem>
          </Col>
        </Row>
      </Row>
      <Row v-show="params.ctype==='2'">
        <Col span="12">
          <FormItem label="优惠规则:">
            <label><span>固定金额</span>
              <span>{{ params.rule.fixed.amount }}元</span>
            </label>
          </FormItem>
        </Col>
      </Row>
      <Row v-show="params.ctype==='3'">
        <Row v-if="params.rule.quantity.r1.ctype">
          <Col span="12">
            <FormItem label="优惠规则:">
              <span style="padding-right: 20px;">满(数量)</span>
              <label>
                <span>{{ params.rule.quantity.r1.quantitystep }}</span>
              </label>
              <span style="padding-left: 10px;padding-right: 10px;">减(金额)</span>
              <label>
                <span>{{ params.rule.quantity.r1.amount }}</span>
              </label>
            </FormItem>
          </Col>
        </Row>
        <Row v-if="params.rule.quantity.r2.ctype">
          <Col span="12">
            <FormItem label="优惠规则:">
              <span style="padding-right: 10px;">每满(数量)</span>
              <label>
                <span>{{ params.rule.quantity.r2.quantitystep }}</span>
              </label>
              <span style="padding-left: 10px;padding-right: 10px;">减(金额)</span>
              <label>
                <span>{{ params.rule.quantity.r2.amount }}</span>
              </label>
            </FormItem>
          </Col>
        </Row>
      </Row>
      <Row v-show="params.ctype==='4'">
        <Col span="12">
          <FormItem label="优惠规则:">
            <span style="padding-left: 20px;padding-right: 10px;">启用数量:</span>
            <label>
              <span>{{ params.rule.discount.lmtcnt }}</span>
            </label>
            <span style="padding-left: 20px;padding-right: 10px;">折扣:</span>
            <label>
              <span>{{ params.rule.discount.discount }}</span>
            </label><span style="padding-left: 10px;padding-right: 10px;">%</span>
          </FormItem>
        </Col>
      </Row>
      <FormItem label="启用金额:">
        <label>
          <span>{{ params.minAmount }}</span>
        </label>
      </FormItem>
      <!-- <FormItem label="门店限领张数:">
        <label>
          <Input
            placeholder="请输入"
            style="width: 100px;"
            type="number"
            v-model="params.lmtcnt"
          ></Input>
        </label>
      </FormItem> -->
      <FormItem label="有效期:">
        <FormItem>
          <span>{{ params.beginDate.substr(0, 10) }}</span><span
          style="padding-left: 10px;padding-right: 10px;">-</span><span>{{ params.endDate.substr(0, 10) }}</span>
        </FormItem>
      </FormItem>
      <FormItem label="使用说明:">
        <label>
          <span>{{ params.couponDesc }}</span>
        </label>
      </FormItem>
      <FormItem label="生效门店:">
        <RadioGroup v-model="params.scope.typer" @on-change="changeTyper">
          <Radio :label="2" border>
            <span>全部门店</span>
          </Radio>
          <!-- <Radio :label="1" border>
            <span>选择门店</span>
            <span style="padding-left: 15px;"><a @click="showChooseRetModal">选择</a></span>
            <span style="padding-left: 15px;">当前选中<span
              style="padding-left: 5px;padding-right: 5px;">{{ retChoosedList.length }}</span>家门店</span>
          </Radio>
          <br />
          <Radio :label="3" border>
            <span>发放省份</span>
          </Radio>
          <Radio :label="4" border>
            <span>发放资金商</span>
          </Radio> -->
          <br />
          <Radio :label="5" border>
            <span>批量上传</span>
            <br />
            <div class="mupload">
              <Button v-if="params.scope.typer === 5"
                ref="upload" icon="ios-cloud-download-outline" @click="downTemp">下载模板</Button>
              <Upload
                v-if="params.scope.typer === 5"
                ref="upload"
                :show-upload-list="false"
                :action="uploadUrl"
                :data="{fileType:'COUPON_APPLY_RETAILER_TEMPLATE'}"
                :format="['xlsx','xls']"
                :before-upload="beforeUpload"
                :on-success="onSuccess"
                :on-error="onError"
                :max-size="204800000"
                :headers='{"token": $sessionToken()}'>
                <Button icon="ios-cloud-upload-outline" :loading="uploading">上传</Button>
              </Upload>
          </div>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="门店限领张数:" v-if="params.scope.typer === 2">
        <label>
          <Input
            placeholder="请输入"
            style="width: 100px;"
            type="number"
            v-model="params.lmtcnt"
          ></Input>
        </label>
      </FormItem>
      <!-- <FormItem v-if="params.scope.typer === 3" label="发放省份:" prop="typerList">
        <Select v-model="params.scope.typerList" multiple>
            <Option v-for="item in areaList" :key="item.code" :value="item.code">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem v-if="params.scope.typer === 4" label="发放资金商:" prop="typerList">
        <Select v-model="params.scope.typerList" multiple>
            <Option v-for="item in merchantList" :key="item.code" :value="item.code">{{item.name}}</Option>
        </Select>
      </FormItem> -->
      <FormItem label="商品范围:">
        <RadioGroup v-model="params.scope.typeg">
          <Radio :label="2" border>
            <span>全部商品</span>
          </Radio>
          <Radio :label="1" border>
            <span>选择商品</span>
            <span style="padding-left: 15px;"><a @click="showChooseSKUModal">选择</a></span>
            <span style="padding-left: 15px;">当前选中<span
              style="padding-left: 5px;padding-right: 5px;">{{ skuChoosedList.length }}</span>种商品</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="优惠券叠加:">
        <RadioGroup v-model="params.scope.typem">
          <Radio :label="2" border>
            <span>无</span>
          </Radio>
          <Radio :label="1" border>
            <span>选择优惠券类型</span>
            <span style="padding-left: 15px;"><a @click="showChooseMUTModal">选择</a></span>
            <span style="padding-left: 15px;">当前选中<span
              style="padding-left: 5px;padding-right: 5px;">{{ mutChoosedList.length }}</span>种优惠券模板</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="优惠券失效:">
        <RadioGroup v-model="params.scope.typed">
          <Radio :label="2" border>
            <span>无</span>
          </Radio>
          <Radio :label="1" border>
            <span>选择优惠券类型</span>
            <span style="padding-left: 15px;"><a @click="showChooseDISModal">选择</a></span>
            <span style="padding-left: 15px;">当前选中<span
              style="padding-left: 5px;padding-right: 5px;">{{ disChoosedList.length }}</span>种优惠券模板</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <!-- <FormItem label="发放规则:">
        <RadioGroup v-model="params.issueRule">
          <Radio :key="item.code" v-for="item in ruleList" :label="item.code">
              {{item.name}}
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem  label="注册天数:" prop="" v-if="params.issueRule === 3">
          <Input
            placeholder="请输入"
            style="width: 100px;"
            type="number"
            v-model="params.regDays"
          ></Input>
      </FormItem> -->
      <FormItem>
        <Button type="primary" @click="saveCouponApply" v-if="!this.viewMode">{{
          mode === "edit" ? "修改" : "添加"
          }}
        </Button>
        <Button style="margin-left: 8px" @click="back">返回</Button>
      </FormItem>
    </Form>

    <Modal
      v-model="modalRet"
      title="选择优惠券生效门店"
      width="900"
      @on-ok="chooseRetailerOk"
      @on-cancel="chooseRetailerCancel"
    >
      <Form :label-width="80" inline @submit.native.prevent>
        <Row>
          <Col span="24">
            <FormItem>
              <label>
                <Input
                  placeholder="门店名称"
                  style="width: 100px;"
                  v-model="searchRetForm.searchKeyStr"
                ></Input>
              </label>
            </FormItem>
            <FormItem>
              <label>
                <Select stype="width:100px;" v-model="searchRetForm.grade" placeholder="门店等级">
                  <Option value="">=全部=</Option>
                  <Option v-for="(item, i) in RetailerGradeList"
                          :key="i" :value="item.gradeCode">{{item.grade}}
                  </Option>
                </Select>
              </label>
            </FormItem>
            <FormItem>
              <label>
                <Select style="width:100px;" v-model="searchRetForm.retType" placeholder="门店类型">
                  <Option value="">=全部=</Option>
                  <Option v-for="(item, i) in RetailerTypeList"
                          :key="i" :value="item.code">{{ item.name }}
                  </Option>
                </Select>
              </label>
            </FormItem>
            <FormItem>
              <Button type="primary" icon="md-search" @click="queryRetailer">查询</Button>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem>
              <Table class="table" border stripe height="400" width="300"
                     :columns="retcolumnlist"
                     :data="retList"
                     @on-selection-change="selectRetLeft"
              >
              </Table>
              <page :total="this.searchRetForm.total" :page-size="this.searchRetForm.pageSize"
                    @on-change="retPageNumChange"
                    @on-page-size-change="retPageSizeChange"
                    show-total
                    class-name="pagination justify-content-end mg-10" style="padding-top: 5px;"/>
            </FormItem>
            <FormItem style="margin-top: 100px; margin-left: -60px;">
              <Button type="primary" @click="transRetToRight">>></Button>
            </FormItem>
            <FormItem style="margin-top: 200px; margin-left: -140px;margin-right: -60px;">
              <Button type="primary" @click="transRetToLeft"><<</Button>
            </FormItem>
            <FormItem>
              <Table class="table" border stripe height="400" width="300"
                     :columns="retcolumnlist1"
                     :data="retChoosedWithNameList"
                     @on-selection-change="selectRetRight"
              >
              </Table>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>

    <Modal
      v-model="modalSku"
      title="选择优惠券生效商品"
      width="700"
      @on-ok="chooseSKUOk"
      @on-cancel="chooseSKUCancel"
    >
      <Form :label-width="80" inline @submit.native.prevent>
        <Row>
          <Col span="24">
            <FormItem>
              <label>
                <span>商品名称:</span>
                <Input
                  placeholder="商品名称"
                  style="width: 100px;"
                  v-model="searchSkuForm.name"
                ></Input>
              </label>
            </FormItem>
            <FormItem>
              <Button type="primary" icon="md-search" @click="querySku">查询</Button>
            </FormItem>
          </Col>
        </Row>
        <Row span="24">
          <Table class="table" border stripe height="400"
                 :columns="skucolumnlist"
                 :data="skuList"
                 @on-selection-change="selectSku"
          >
            <template slot-scope="{row, column, index}" slot="lmtCnt">
              <label>
                <InputNumber placeholder="数量" :min=0 v-model="skuCnt[index]" name="skulmtCnt"
                             style="width:60px;"></InputNumber>
              </label>
            </template>
          </Table>
        </Row>
      </Form>
    </Modal>

    <Modal
      v-model="modalMut"
      title="选择优惠券叠加规则"
      width="700"
      @on-ok="chooseMutOk"
      @on-cancel="chooseMutCancel"
    >
      <Form :label-width="80" inline @submit.native.prevent>
        <Row>
          <Col span="24">
            <FormItem>
              <label>
                <span>优惠券模板名称:</span>
                <Input
                  placeholder="优惠券模板名称"
                  style="width: 100px;"
                  v-model="searchMutForm.cname"
                ></Input>
              </label>
            </FormItem>
            <FormItem>
              <Button type="primary" icon="md-search" @click="queryCouponMut">查询</Button>
            </FormItem>
          </Col>
        </Row>
        <Row span="24">
          <Table class="table" border stripe height="400"
                 :columns="coupontmpcolumnlist"
                 :data="mutList"
                 @on-selection-change="selectMut"
          >
          </Table>
        </Row>
      </Form>
    </Modal>

    <Modal
      v-model="modalDis"
      title="选择优惠券失效规则"
      width="700"
      @on-ok="chooseDisOk"
      @on-cancel="chooseDisCancel"
    >
      <Form :label-width="80" inline @submit.native.prevent>
        <Row>
          <Col span="24">
            <FormItem>
              <label>
                <span>优惠券模板名称:</span>
                <Input
                  placeholder="优惠券模板名称"
                  style="width: 100px;"
                  v-model="searchDisForm.cname"
                ></Input>
              </label>
            </FormItem>
            <FormItem>
              <Button type="primary" icon="md-search" @click="queryCouponDis">查询</Button>
            </FormItem>
          </Col>
        </Row>
        <Row span="24">
          <Table class="table" border stripe height="400"
                 :columns="coupontmpcolumnlist"
                 :data="disList"
                 @on-selection-change="selectDis"
          >
          </Table>
        </Row>
      </Form>
    </Modal>

  </div>
</template>

<script>
import axios from 'axios';
  const retcolumnlist = [
    {
      align: 'center',
      type: 'selection',
      width: 80
    },
    {
      title: '门店列表',
      key: 'retName',
      width: 300
    }
  ];
  const retcolumnlist1 = [
    {
      align: 'center',
      type: 'selection',
      width: 80
    },
    {
      title: '已选门店',
      key: 'retName',
      width: 300
    }
  ];
  const skucolumnlist = [
    {
      align: 'center',
      type: 'selection',
      width: 80
    },
    {
      title: '名称',
      key: 'name',
      width: 300
    },
    {
      title: '启用数量',
      slot: 'lmtCnt',
      width: 150
    }
  ];
  const coupontmpcolumnlist = [
    {
      align: 'center',
      type: 'selection',
      width: 80
    },
    {
      title: '名称',
      key: 'cname',
      tooltip: true,
      width: 200
    }, {
      title: '类型',
      key: 'ctypeName',
      width: 150
    }, {
      title: '生效日期',
      key: 'beginDate',
      width: 120
    }, {
      title: '失效日期',
      key: 'endDate',
      width: 120
    }
  ];
  export default {
    name: "create",
    data() {
      return {
        mode: '',
        viewMode: false,
        CoupontempType: {},
        CouponPlatform: {},
        RetailerGradeList: [],
        RetailerTypeList: [],
        params: {
          applyCode: '',
          code: null,
          cname: '',
          platformCode: '',
          platformName: '',
          ctype: '',
          ctypeName: '',
          rule: {
            meet: {
              r1: {ctype: true, amountstep: 0, amount: 0},
              r2: {ctype: false, amountstep: 0, amount: 0}
            },
            fixed: {amount: 0},
            quantity: {
              r1: {ctype: true, quantitystep: 0, amount: 0},
              r2: {ctype: false, quantitystep: 0, amount: 0}
            },
            discount: {lmtcnt: 0, discount: 100},
          },
          scope: {
            code: '',
            applyCode: '',
            typer: 2,
            typerList: [],
            typerCntList: [],
            typeg: 2,
            typegList: [],
            typegCntList: [],
            typem: 2,
            typemList: [],
            typed: 2,
            typedList: []
          },
          minAmount: '',
          lmtcnt: '',
          regDays: 0,
          couponDesc: '',
          ruleDetail: '',
          status: "0",
          beginDate: '',
          endDate: '',

          batchNo: '',
          name: '',
          source: '',
          templateCode: '',
          operator: window.sessionStorage.getItem("name") +
            "(" + window.sessionStorage.getItem("loginId") + ")",
          issueRule: 1,
        },
        modalRet: false,
        modalSku: false,
        modalMut: false,
        modalDis: false,

        retcolumnlist,
        retcolumnlist1,
        skucolumnlist,
        coupontmpcolumnlist,

        retailerTypelist: [],
        retList: [],
        retChkedLeftList: [],
        retChkedRightList: [],
        retChoosedList: [],
        retChoosedWithNameList: [],
        searchRetForm: {
          pageNum: 1,
          page: 1,
          pageSize: 20,
          platformCode: '',
          platformStatus: '1',
          //dealerCode: "",
          searchKeyStr: "",
          retType: "",
          grade: '',
          total: 0
        },

        skuList: [],
        skuCnt: [],
        skuChoosedCnt: [],
        skuChkedList: [],
        skuChoosedList: [],
        searchSkuForm: {
          //brandCode: this.brandCode,
          //categoryCode: this.categoryCode,
          name: '',
          platformCode: '',
          status: '02',
        },

        mutList: [],
        mutChkedList: [],
        mutChoosedList: [],
        searchMutForm: {
          code: '',
          cname: '',
          platformCode: '',
          ctype: "",
          status: "0",
          beginDate: '',
          endDate: '',
          pageSize: 100000,
          pageNum: 1
        },

        disList: [],
        disChkedList: [],
        disChoosedList: [],
        searchDisForm: {
          code: '',
          cname: '',
          platformCode: '',
          ctype: "",
          status: "0",
          beginDate: '',
          endDate: '',
          pageSize: 100000,
          pageNum: 1
        },

        ruleValidate: {
          cname: [
            {required: true, message: '请输入优惠券名称', trigger: 'blur'}
          ],
        },
        uploading: false,
        areaList: [], // 发放省份列表
        merchantList: [], // 发放资金商列表
        ruleList: [], // 发放规则列表
      };
    },
    methods: {
      showPlatformName(code) {
        for (let i = 0; i < this.CouponPlatform.length; i++) {
          if (code === this.CouponPlatform[i].code) {
            return this.CouponPlatform[i].name;
          }
        }
      },
      queryCoupontemptype() {
        let http = 'couponTemplateType';
        this.$api[http]({}).then((res) => {
          if (res.code === '200') {
            //this.$Message.success('查询优惠券类型枚举成功');
            this.CoupontempType = res.data.CoupontempType;
          } else {
            this.$Message.error('查询优惠券类型枚举失败.');
          }
        });
      },
      queryBusiPlatform() {
        let http = 'couponqueryBusiPlatform';
        this.$api[http]({}).then((res) => {
          if (res.code === '200') {
            //this.$Message.success('查询优惠券业务平台枚举成功');
            this.CouponPlatform = res.data.CouponPlatform;
          } else {
            this.$Message.error('查询优惠券业务平台枚举失败.');
          }
        });
      },
      saveCouponApply() {
        let retChooseCnt = 300;
        if (this.retChoosedList.length > retChooseCnt) {
          this.$Message.error("生效门店中已选门店数量不能不能超过" + retChooseCnt + "家，请减少数量");
          return;
        }
        if (this.mode === 'add') {
          this.createCouponApplyByTemplate();
        }
        if (this.mode === 'edit') {
          this.updateCouponApply();
        }
      },
      createCouponApplyByTemplate() {
        this.$refs['params'].validate((valid) => {
          if (!valid) {
            this.$Message.error('数据校验失败,请检查输入的数据.');
          } else {
            let txtlist = document.getElementsByName("skulmtCnt");
            this.params.scope.typegCntList = [];
            for (let i = 0; i < this.skuList.length; i++) {
              for (let n = 0; n < this.skuChoosedList.length; n++) {
                if (this.skuList[i].code === this.skuChoosedList[n]) {
                  this.params.scope.typegCntList.push(txtlist[i].value);
                }
              }
            }
            if (this.params.scope.typer <= 2) {
               this.params.scope.typerList = this.retChoosedList;
            }
            this.params.scope.typegList = this.skuChoosedList;
            this.params.scope.typemList = this.mutChoosedList;
            this.params.scope.typedList = this.disChoosedList;
            this.params.regDays = Number(this.params.regDays);
            this.$api['createCouponApplyByTemplate'](this.params).then((res) => {
              if (res.code === '200') {
                this.$Message.success('创建优惠券发放申请成功');
                this.$router.go(-1);
              } else {
                this.$Message.error('创建优惠券发放申请失败.');
              }
            });
          }
        });
      },
      updateCouponApply() {
        this.$refs['params'].validate((valid) => {
          if (!valid) {
            this.$Message.error('数据校验失败,请检查输入的数据.');
          } else {
            let txtlist = document.getElementsByName("skulmtCnt");
            this.params.scope.typegCntList = [];
            for (let i = 0; i < this.skuList.length; i++) {
              for (let n = 0; n < this.skuChoosedList.length; n++) {
                if (this.skuList[i].code === this.skuChoosedList[n]) {
                  this.params.scope.typegCntList.push(txtlist[i].value);
                }
              }
            }
            if (this.params.scope.typer <= 2) {
            this.params.scope.typerList = this.retChoosedList;
            }
            this.params.scope.typegList = this.skuChoosedList;
            this.params.scope.typemList = this.mutChoosedList;
            this.params.scope.typedList = this.disChoosedList;
            this.params.regDays = Number(this.params.regDays);
            this.$api['updateCouponApply'](this.params).then((res) => {
              if (res.code === '200') {
                this.$Message.success('修改优惠券发放申请成功');
                this.$router.go(-1);
              } else {
                this.$Message.error('修改优惠券发放申请失败,' + res.message);
              }
            });
          }
        });
      },
      queryTemplateDetail() {
        let http = 'queryTemplateDetail';
        this.$api[http](this.params).then((res) => {
          if (res.code === '200') {
            this.$Message.success('查询优惠券模板信息成功');
            let c = res.data;
            this.params.code = c.code;
            this.params.cname = c.cname;
            this.params.platformCode = c.platformCode;
            this.params.platformName = this.showPlatformName(c.platformCode);
            this.params.ctype = c.ctype.toString();
            this.params.ctypeName = c.ctypeName;
            this.params.minAmount = c.minAmount;
            this.params.lmtcnt = c.lmtCnt;
            this.params.status = c.status;
            this.params.beginDate = c.beginDate;
            this.params.endDate = c.endDate;
            this.params.couponDesc = c.couponDesc;
            this.params.ruleDetail = c.ruleDetail;
            this.queryRuleDetail();
            if (this.params.applyCode !== '' && this.params.applyCode !== undefined) {
              this.queryCouponApplyInfo();
            }
            this.queryRetailerTypelist();
          } else {
            this.$Message.error('查询优惠券模板失败.');
          }
        });
      },
      queryCouponApplyInfo() {
        this.$api['queryCouponApplySim'](this.params).then((res) => {
          if (res.code === '200') {
            this.$Message.success('查询优惠券发放信息成功');
            let c = res.data;
            this.params.applyCode = c.code;
            this.params.cname = c.name;
            this.params.status = c.status;
            this.params.templateCode = c.templateCode;
            this.params.source = c.source;
            this.params.status = c.status;
            this.params.batchNo = c.batchNo;
            this.params.scope.applyCode = c.code;
            this.params.issueRule = c.issueRule||1;
            this.params.regDays = c.regDays||0;
            this.queryCouponScopeInfo();
          }
        });
      },
      queryCouponScopeInfo() {
        this.$api['queryCouponScopeByApplyCode'](this.params.scope).then((res) => {
          if (res.code === '200') {
            this.$Message.success('查询优惠券发放范围信息成功');
            let c = res.data;
            this.params.scope.code = c.code;
            this.params.scope.typer = c.typeR;
            this.params.scope.typeg = c.typeG;
            this.params.scope.typem = c.typeM;
            this.params.scope.typed = c.typeD;
            if (c.typeR === 1 || c.typeR === 3 || c.typeR === 4 || c.typeR === 5) {
              this.queryCouponScopeList(c.code, 1, c.typeR)
            }
            if (c.typeG === 1) {
              this.queryCouponScopeList(c.code, 2)
            }
            if (c.typeM === 1) {
              this.queryCouponScopeList(c.code, 3)
            }
            if (c.typeD === 1) {
              this.queryCouponScopeList(c.code, 4)
            }
          }
        });
      },
      queryCouponScopeList(scopeCode, stype, typeR) {
        let query = {
          scopeCode: scopeCode,
          stype: stype
        };
        this.$api['queryCouponScopeList'](query).then((res) => {
          if (res.code === '200') {
            if (stype === 1) {
              this.retChoosedList = [];
              res.data.forEach(
                (d) => {
                  if(typeR && (typeR === 3 || typeR === 4  || typeR === 5)){
                    this.params.scope.typerList.push(d.itemCode);
                    if(typeR === 5){
                      this.params.scope.typerList.push(d.lmtCnt);
                    }
                  }
                  this.retChoosedList.push(d.itemCode);
                  this.retChoosedWithNameList.push({retCode: d.itemCode, retName: d.itemName})
                }
              );
            }
            if (stype === 2) {
              this.skuChoosedList = [];
              res.data.forEach(
                (d) => {
                  this.skuChoosedList.push(d.itemCode);
                  this.skuChoosedCnt.push(d.lmtCnt);
                }
              );
            }
            if (stype === 3) {
              this.mutChoosedList = [];
              res.data.forEach(
                (d) => {
                  this.mutChoosedList.push(d.itemCode);
                }
              );
            }
            if (stype === 4) {
              this.disChoosedList = [];
              res.data.forEach(
                (d) => {
                  this.disChoosedList.push(d.itemCode);
                }
              );
            }
          }
        });
      },
      queryRuleDetail() {
        let rule = JSON.parse(this.params.ruleDetail);
        if (this.params.ctype === '1') {
          let meetr = {ctype: true, amountstep: rule.amountStep, amount: rule.amount};
          if (rule.cType === '0') {
            this.params.rule.meet.r1 = meetr;
            this.params.rule.meet.r2.ctype = false;
          }
          if (rule.cType === '1') {
            this.params.rule.meet.r2 = meetr;
            this.params.rule.meet.r1.ctype = false;
          }
        }
        if (this.params.ctype === '2') {
          this.params.rule.fixed.amount = rule.amount;
        }
        if (this.params.ctype === '3') {
          let quanr = {ctype: true, quantitystep: rule.quantityStep, amount: rule.amount};
          if (rule.cType === '0') {
            this.params.rule.quantity.r1 = quanr;
            this.params.rule.quantity.r2.ctype = false;
          }
          if (rule.cType === '1') {
            this.params.rule.quantity.r2 = quanr;
            this.params.rule.quantity.r1.ctype = false;
          }
        }
        if (this.params.ctype === '4') {
          this.params.rule.discount.lmtcnt = rule.lmtCnt;
          this.params.rule.discount.discount = rule.discount * 100;
        }
        // let query = {
        //   templateCode: this.params.code,
        //   ruleType: this.params.ctype
        // };
        // let http = 'queryRuleDetail';
        // this.$api[http](query).then((res) => {
        //   if (res.code === '200') {
        //     let rule = res.data;
        //     if (this.params.ctype === '1') {
        //       let meetr = {ctype: true, amountstep: rule.amountStep, amount: rule.amount};
        //       if (rule.ctype === '0') {
        //         this.params.rule.meet.r1 = meetr;
        //         this.params.rule.meet.r2.ctype = false;
        //       }
        //       if (rule.ctype === '1') {
        //         this.params.rule.meet.r2 = meetr;
        //         this.params.rule.meet.r1.ctype = false;
        //       }
        //     }
        //     if (this.params.ctype === '2') {
        //       this.params.rule.fixed.amount = rule.amount;
        //     }
        //     if (this.params.ctype === '3') {
        //       let quanr = {ctype: true, quantitystep: rule.quantityStep, amount: rule.amount};
        //       if (rule.ctype === '0') {
        //         this.params.rule.quantity.r1 = quanr;
        //         this.params.rule.quantity.r2.ctype = false;
        //       }
        //       if (rule.ctype === '1') {
        //         this.params.rule.quantity.r2 = quanr;
        //         this.params.rule.quantity.r1 = false;
        //       }
        //     }
        //     if (this.params.ctype === '4') {
        //       this.params.rule.discount.lmtcnt = rule.lmtCnt;
        //       this.params.rule.discount.discount = rule.discount * 100;
        //     }
        //   }
        // });
      },
      back() {
        this.$router.back();
      },

      //********************************************************
      queryBaseRetailerType() {
        this.retailerTypelist = [];
        this.$api['baseRetailerType']({}).then((res) => {
          if (res.code === '200') {
            this.retailerTypelist = res.data;
          } else {
          }
        });
      },
      showChooseRetModal() {
        this.modalRet = true;
        this.queryRetailer();
      },
      queryRetailerGrade() {
        this.$api['gradeSearchAll'](this.searchRetForm).then((res) => {
          if (res.code === '200') {
            this.RetailerGradeList = res.data;
          }
        });
      },
      queryRetailer() {
        this.searchRetForm.platformCode = this.params.platformCode;
        this.$api['shopInfoQueryList'](this.searchRetForm).then((res) => {
          if (res.code === '200') {
            this.retList = res.data;
            this.searchRetForm.total = res.total;
            // this.retChkedLeftList = [];
            // this.retList.forEach(
            //   (d) => {
            //     for (let i = 0; i < this.retChoosedList.length; i++) {
            //       if (d.retCode === this.retChoosedList[i]) {
            //         d._checked = true;
            //         this.retChkedLeftList.push(d);
            //       }
            //     }
            //   }
            // );
          }
        });
      },
      queryRetailerTypelist() {
        let query = {
          "platformCode": this.params.platformCode,
          "page": 1, "pageSize": 1000
        };
        this.$api['baseRetailerTypeList'](query).then((res) => {
          if (res.code === '200') {
            this.RetailerTypeList = res.data;
          }
        });
      },
      selectRetLeft(s) {
        this.retChkedLeftList = s;
      },
      selectRetRight(s) {
        this.retChkedRightList = s;
      },
      retPageNumChange(p) {
        this.searchRetForm.page = p;
        this.queryRetailer();
      },
      retPageSizeChange(p) {
        this.searchRetForm.pageSize = p;
        this.queryRetailer();
      },
      transRetToRight() {
        this.retChkedLeftList.forEach(
          (l) => {
            let b = false;
            this.retChoosedWithNameList.forEach(
              (r) => {
                if (l.retCode === r.retCode) {
                  b = true;
                }
              }
            );
            if (!b) {
              this.retChoosedWithNameList.push({retCode: l.retCode, retName: l.retName});
            }
          }
        );
      },
      transRetToLeft() {
        for (let i = 0; i < this.retChoosedWithNameList.length; i++) {
          this.retChkedRightList.forEach(
            (r) => {
              if (this.retChoosedWithNameList[i].retCode === r.retCode) {
                this.retChoosedWithNameList.splice(i, 1);
              }
            }
          );
        }
      },
      chooseRetailerOk() {
        this.retChoosedList = [];
        let s = this.retChoosedWithNameList;
        if (s.length > 0) {
          for (let i = 0; i < s.length; i++) {
            this.retChoosedList.push(s[i].retCode);
          }
        }
        this.modalRet = false;
      },
      chooseRetailerCancel() {
        this.modalRet = false;
      },
      //*************************************************************
      showChooseSKUModal() {
        this.modalSku = true;
        this.querySku();
      },
      querySku() {
        this.searchSkuForm.platformCode = this.params.platformCode;
        this.$api['skuSearch'](this.searchSkuForm).then((res) => {
          if (res.code === '200') {
            this.skuList = res.data;
            this.skuList.forEach(
              (d) => {
                this.skuCnt.push(1);
                for (let i = 0; i < this.skuChoosedList.length; i++) {
                  if (d.code === this.skuChoosedList[i]) {
                    d._checked = true;
                  }
                }
              }
            );
            for (let i = 0; i < this.skuList.length; i++) {
              for (let n = 0; n < this.skuChoosedList.length; n++) {
                if (this.skuList[i].code === this.skuChoosedList[n]) {
                  this.skuCnt[i] = this.skuChoosedCnt[n];
                }
              }
            }
          }
        });
      },
      selectSku(s) {
        this.skuChkedList = s;
        this.skuChoosedList = [];
        if (s.length > 0) {
          for (let i = 0; i < s.length; i++) {
            this.skuChoosedList.push(s[i].code);
          }
        }
      },
      chooseSKUOk() {
        this.skuChoosedList = [];
        let s = this.skuChkedList;
        if (s.length > 0) {
          for (let i = 0; i < s.length; i++) {
            this.skuChoosedList.push(s[i].code);
          }
        }
        this.modalSku = false;
      },
      chooseSKUCancel() {
        this.modalSku = false;
      },
      //*************************************************************
      showChooseMUTModal() {
        this.modalMut = true;
        this.queryCouponMut();
      },
      queryCouponMut() {
        this.searchMutForm.platformCode = this.params.platformCode;
        this.$api['queryCouponTemplatelist'](this.searchMutForm).then((res) => {
          if (res.code === '200') {
            this.mutList = res.data.list;
            this.mutList.forEach(
              (t) => {
                t.beginDate = t.beginDate.substr(0, 10);
                t.endDate = t.endDate.substr(0, 10);
                t.platformName = this.showPlatformName(t.platformCode);

                for (let i = 0; i < this.mutChoosedList.length; i++) {
                  if (t.code === this.mutChoosedList[i]) {
                    t._checked = true;
                  }
                }
              }
            );
          }
        });
      },
      selectMut(s) {
        this.mutChkedList = s;
        this.mutChoosedList = [];
        if (s.length > 0) {
          for (let i = 0; i < s.length; i++) {
            this.mutChoosedList.push(s[i].code);
          }
        }
      },
      chooseMutOk() {
        this.mutChoosedList = [];
        let s = this.mutChkedList;
        if (s.length > 0) {
          for (let i = 0; i < s.length; i++) {
            this.mutChoosedList.push(s[i].code);
          }
        }
        this.modalMut = false;
      },
      chooseMutCancel() {
        this.modalMut = false;
      },
      //*************************************************************
      showChooseDISModal() {
        this.modalDis = true;
        this.queryCouponDis();
      },
      queryCouponDis() {
        this.searchDisForm.platformCode = this.params.platformCode;
        this.$api['queryCouponTemplatelist'](this.searchDisForm).then((res) => {
          if (res.code === '200') {
            this.disList = res.data.list;
            this.disList.forEach(
              (t) => {
                t.beginDate = t.beginDate.substr(0, 10);
                t.endDate = t.endDate.substr(0, 10);
                t.platformName = this.showPlatformName(t.platformCode);

                for (let i = 0; i < this.disChoosedList.length; i++) {
                  if (t.code === this.disChoosedList[i]) {
                    t._checked = true;
                  }
                }
              }
            );
          }
        });
      },
      selectDis(s) {
        this.disChkedList = s;
        this.disChoosedList = [];
        if (s.length > 0) {
          for (let i = 0; i < s.length; i++) {
            this.disChoosedList.push(s[i].code);
          }
        }
      },
      chooseDisOk() {
        this.disChoosedList = [];
        let s = this.disChkedList;
        if (s.length > 0) {
          for (let i = 0; i < s.length; i++) {
            this.disChoosedList.push(s[i].code);
          }
        }
        this.modalDis = false;
      },
      chooseDisCancel() {
        this.modalDis = false;
      },
      beforeUpload(d) {
        let types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
        if (types.indexOf(d.type) == -1) {
          this.$Message.error('请上传Excel文件');
          return false;
        }
        this.uploading = true;
      },
      onError() {
        this.uploading = false;
        this.$Message.error('上传失败');
      },
      onSuccess(response) {
        this.uploading = false;
        let data = response.data;
        if(response.code === '200'){
          this.$api['batchImportRet'](Object.assign({
          operator: this.params.operator
        }, data)).then((res) => {
          if (res.code === '200' && res.data) {
            this.params.scope.typerList = res.data.map(d=>d.retCode);
            this.params.scope.typerCntList = res.data.map(d=>d.cnt);
          } else {
            this.$Message.error('批量导入失败');
          }
        });
        } else {
          this.$Message.error('上传文件失败');
        }
      },
      downTemp(){
        this.$api['templateFile']({fileType: 'COUPON_APPLY_RETAILER_TEMPLATE'}).then((res) => {
          if (res.code === '200' && res.data) {
            window.open(res.data, '_self')
          } else {
            this.$Message.error('模板下载失败');
          }
        });
      },
      /*
      * 查询地区
      */
      queryAreas(){
        this.$api.areaQuery({parent:"AAA001"}).then((res) => {
            if(res.code == '200'){
                this.areaList = res.data;
            }
        });
      },
      /*
      * 查询资金商
      */
      queryZJS(){
        this.$api.spInfoQueryAll({}).then((res) => {
            if(res.code == '200'){
                this.merchantList = res.data;
            }
        });
      },
      /*
      * 查询规则
      */
      queryCouponScopeIssueRule(){
        this.$api.queryCouponScopeIssueRule({}).then((res) => {
            if(res.code == '200'){
                this.ruleList = res.data.map(d=>{
                  d.code = Number(d.code);
                  return d;
                });
            }
        });
      },
      changeTyper(){
        this.params.scope.typerList = [];
        this.params.scope.typerCntList = [];
      }
    },
    created() {
      if (this.$route.query.viewMode) {
        this.viewMode = true;
      }
      this.params.code = this.$route.query.code;
      this.params.applyCode = this.$route.query.applyCode;
      if (this.params.applyCode) {
        this.mode = 'edit';
      } else {
        this.mode = 'add';
      }

      this.queryBaseRetailerType();
      this.queryBusiPlatform();
      this.queryRetailerGrade();
      this.queryAreas();
      this.queryZJS();
      this.queryCouponScopeIssueRule();

      this.uploadUrl = axios.defaults.baseURL + 'base/template/uploadFile';
    },
    watch: {
      CouponPlatform(n, o) {
        this.queryCoupontemptype();
      },
      CoupontempType(n, o) {
        this.queryTemplateDetail();
      }
    }
  }
</script>

<style scoped>
  .mupload{
    display: flex;
    align-items: flex-start;
  }
  .mupload .ivu-btn {
      margin:0 0 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/coupon/apply/create.vue